import { SideNav } from '@neo.tax/shared';

import { useSredNavSections } from './hooks';

export const SredSideNav = (): React.ReactElement => {
  const sections = useSredNavSections();
  return <SideNav sections={sections} variant="dark" gap={4} />;
};
